
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"gp-design-system"},[_c('gpal-login',{attrs:{"configEmail":config.email}})],1)}},
      staticRenderFns: []
    };
  